import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import MultiSelectFilter from "../../CommonMultiSelectFilter/MultiSelectFilter";
import axiosInstance from "../../axiosInstance";
import { toast } from "react-toastify";

const BillingAutomationFilter = ({
    onApply,
    onReset,
}) => {
    const [automationCode, setAutomationCode] = useState([]);
    const [contractCode, setContractCode] = useState([]);
    const [plantCode, setPlantCode] = useState([]);
    const [city, setCity] = useState([]);
    const [state, setState] = useState([]);
    const [zone, setZone] = useState([]);

    const [dateRange, setDateRange] = useState([
        null,
        null,
    ]);

    const [fromDate, toDate] = dateRange;

    const zoneOptions = [
        { label: "North", value: "north" },
        { label: "South", value: "south" },
        { label: "East", value: "east" },
        { label: "West", value: "west" },
    ];

    const loadOptions = async (
        url,
        key,
        inputValue
    ) => {
        try {
            const res = await axiosInstance.get(url, {
                params: { term: inputValue || "" },
            });

            return (
                res.data?.[key] || []
            ).map((item) => ({
                label: item.label,
                value: item.value,
            }));
        } catch {
            return [];
        }
    };

    const handleApply = () => {
        const payload = {
            automationCode: automationCode.map(
                (x) => x.value
            ),
            contractCode: contractCode.map(
                (x) => x.value
            ),
            plantCode: plantCode.map((x) => x.value),
            fromDate,
            toDate,
            city: city.map((x) => x.value),
            state: state.map((x) => x.value),
            zone: zone.map((x) => x.value),
        };

        onApply(payload);
    };

    const handleReset = () => {
        setAutomationCode([]);
        setContractCode([]);
        setPlantCode([]);
        setCity([]);
        setState([]);
        setZone([]);
        setDateRange([null, null]);

        onReset();
    };

    const customSelectStyles = {
        control: (base, state) => ({
            ...base,
            minHeight: "40px",
            borderRadius: "12px",
            fontSize: "13px",
            width: "100%",
            borderColor: state.isFocused ? "#454CF2" : "#D0D6DF",
            boxShadow: state.isFocused ? "0 0 0 1px #454CF2" : "none",
            "&:hover": { borderColor: "#454CF2" },
        }),
        container: (base) => ({ ...base, width: "100%" }),
        menu: (base) => ({ ...base, fontSize: "12px" }),
        menuList: (base) => ({
            ...base,
            maxHeight: "250px",
            overflowY: "auto"
        }),
        multiValue: (base) => ({
            ...base,
            backgroundColor: '#F0F4F8',
            borderRadius: '4px',
            padding: '2px 6px',
            margin: '2px',
            maxWidth: '120px',
        }),
        multiValueLabel: (base) => ({
            ...base,
            color: '#19324C',
            fontSize: '12px',
            fontWeight: 500
        }),
        valueContainer: (base) => ({
            ...base,
            maxHeight: "35px",
            height: "40px",
            overflowY: "auto",
            overflowX: "hidden",
            flexWrap: "wrap",
            alignItems: "center",
            paddingTop: "4px",
            paddingBottom: "4px",
        }),
        multiValueRemove: (base) => ({
            ...base,
            color: '#19324C',
            ':hover': {
                backgroundColor: 'transparent',
                color: '#ff0000'
            }
        })
    };

    return (
        <div className="filter-scope" style={{
            padding: "15px",
            border: "1px solid #E5E5E5",
            borderRadius: "12px",
        }}>

            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p className="filter-header">Filter</p>
            </div>

            <div className="filter-all" style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr",
                gap: "12px",
                marginTop: "15px",
            }}>

                <MultiSelectFilter
                    label="Automation Code"
                    value={automationCode}
                    onChange={setAutomationCode}
                    loadOptions={(input) =>
                        loadOptions(
                            "/automation/autocomplete",
                            "autosuggestion",
                            input
                        )
                    }
                    styles={customSelectStyles}
                    placeholder="Select Automation Code"
                />

                <MultiSelectFilter
                    label="Contract Code"
                    value={contractCode}
                    onChange={setContractCode}
                    loadOptions={(input) =>
                        loadOptions(
                            "/contract/get_contractcode",
                            "suggestionlist",
                            input
                        )
                    }
                    styles={customSelectStyles}
                    placeholder="Select Contract Code"
                />

                <MultiSelectFilter
                    label="Plant Code"
                    value={plantCode}
                    onChange={setPlantCode}
                    loadOptions={(input) =>
                        loadOptions(
                            "/plant_code/autosuggestion",
                            "autosuggestion",
                            input
                        )
                    }
                    styles={customSelectStyles}
                    placeholder="Select Plant Code"
                />

                <div className="filter-field">
                    <p className="filter-text">Date Range</p>

                    <DatePicker
                        selectsRange
                        startDate={fromDate}
                        endDate={toDate}
                        onChange={(update) =>
                            setDateRange(update)
                        }
                        isClearable
                        placeholderText="Select Date Range"
                        className="form-control"
                    />
                </div>

                <MultiSelectFilter
                    label="City"
                    value={city}
                    onChange={setCity}
                    loadOptions={(input) =>
                        loadOptions(
                            "/get_city",
                            "suggestionlist",
                            input
                        )
                    }
                    styles={customSelectStyles}
                    placeholder="Select City"
                />

                <MultiSelectFilter
                    label="State"
                    value={state}
                    onChange={setState}
                    loadOptions={(input) =>
                        loadOptions(
                            "/get_state",
                            "suggestionlist",
                            input
                        )
                    }
                    styles={customSelectStyles}
                    placeholder="Select State"
                />

                <MultiSelectFilter
                    label="Zone"
                    value={zone}
                    onChange={setZone}
                    options={zoneOptions}
                    isAsync={false}
                    styles={customSelectStyles}
                    placeholder="Select Zone"
                />

                <div className='filter-field'></div>
                <div className='filter-field'></div>

                <div
                    style={{
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "flex-end",
                        gap: "10px"
                    }}
                >
                    <button
                        className="jobs-cancel-btn"
                        onClick={handleReset}
                    >
                        Reset
                    </button>

                    <button
                        className="jobs-apply-btn"
                        onClick={handleApply}
                    >
                        Apply
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BillingAutomationFilter;